import { Component } from 'solid-js';
import { useLocale } from './index';

const LanguageSwitcher: Component = () => {
  const { locale, toggleLocale } = useLocale();

  return (
    <button
      class="language-switcher"
      onClick={toggleLocale}
      aria-label={locale() === 'pl' ? 'Switch to English' : 'Przełącz na polski'}
      title={locale() === 'pl' ? 'Switch to English' : 'Przełącz na polski'}
    >
      <span class={`lang-option ${locale() === 'pl' ? 'active' : ''}`}>PL</span>
      <span class="lang-separator">|</span>
      <span class={`lang-option ${locale() === 'en' ? 'active' : ''}`}>EN</span>
    </button>
  );
};

export default LanguageSwitcher;
